module.exports = __webpack_public_path__ + "img/laser-turret-speed.db1d0386.png";